<template>
  <div>
    <NavBar />
    <div class="container">
      <b-overlay :show="loading" opacity="0.99">
        <v-btn
          v-if="permissions.standard_product.write"
          class="v-primary mb-1"
          v-on:click="handleModalCreate"
        >
          <span class="fa fa-plus"></span> Novo
        </v-btn>
        <!-- Modal create -->
        <b-modal size="xl" id="createProduct" hide-footer>
          <template v-slot:modal-title>Novo produto</template>
          <div class="d-block">
            <div class="container">
              <form v-on:submit="create" method="post">
                <div class="row">
                  <WarningRequiredFields />
                  <ErrorsMessages :errors="errors" />
                  <div class="col-md-8">
                    <LabelRequiredField label="Nome" />
                    <input type="text" v-model="name" class="form-control" />
                  </div>
                  <div class="col-md-2">
                    <LabelRequiredField label="Unidade" />
                    <select
                      v-model="unit_of_measurement_id"
                      class="form-control"
                    >
                      <option
                        v-for="value in unitOfMeasurements"
                        :key="value.id"
                        :value="value.id"
                      >
                        {{ value.name }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-2">
                    <label>Estoque mínimo</label>
                    <input
                      type="text"
                      v-model="minimum_stock"
                      class="form-control"
                    />
                  </div>
                  <div class="col-md-4">
                    <LabelRequiredField label="Categoria" />
                    <div class="input-group">
                      <select
                        v-model="category_standard_product_id"
                        class="form-control"
                      >
                        <option value>Selecione</option>
                        <option
                          v-for="value in categoryProducts"
                          :key="value.id"
                          :value="value.id"
                        >
                          {{ value.name }}
                        </option>
                      </select>
                      <div class="input-group-prepend">
                        <v-btn
                          class="v-secondary"
                          @click="
                            errors = [];
                            $bvModal.show('createCategoryProduct');
                          "
                        >
                          <span class="fa fa-plus"></span> Novo
                        </v-btn>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <LabelRequiredField label="Custo do produto" />
                    <input
                      type="text"
                      v-model="product_cost"
                      class="form-control"
                      v-on:keyup="handleValueProductCost"
                    />
                  </div>
                  <div class="col-md-4">
                    <label>Lucro(%)</label>
                    <input
                      type="text"
                      v-on:keyup="handleValueProfit"
                      v-model="profit"
                      class="form-control"
                    />
                  </div>
                  <div class="col-md-4">
                    <LabelRequiredField label="Valor da venda" />
                    <input
                      type="text"
                      v-model="sale_price"
                      class="form-control"
                      v-on:keyup="handleValueSalePrice"
                    />
                  </div>
                  <div class="col-md-12 text-right">
                    <v-btn
                      :disabled="loadingCreate"
                      type="submit"
                      class="v-success"
                    >
                      <span class="fa fa-check"></span>
                      {{ loadingCreate ? "Carregando" : "Salvar" }}
                    </v-btn>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </b-modal>
        <!-- /Modal create -->
        <!-- Modal new category -->
        <b-modal id="createCategoryProduct" hide-footer>
          <template v-slot:modal-title>Nova categoria</template>
          <div class="d-block">
            <div class="container">
              <form v-on:submit="createCategory" method="post">
                <div class="row">
                  <ErrorsMessages :errors="errors" />
                  <div class="col-md-12">
                    <label>Nome</label>
                    <input
                      type="text"
                      v-model="category_name"
                      class="form-control"
                    />
                  </div>
                  <div class="col-md-12 text-right">
                    <v-btn
                      :disabled="loadingCreateCategory"
                      type="submit"
                      class="v-success"
                    >
                      <span class="fa fa-check"></span>
                      {{ loadingCreateCategory ? "Carregando" : "Salvar" }}
                    </v-btn>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </b-modal>
        <!-- /Modal new category -->
        <v-card>
          <v-card-title>
            Produtos
            <v-spacer />
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Pesquisar"
              single-line
              hide-details
            />
          </v-card-title>
          <v-data-table
            dense
            :headers="headers"
            :items="products"
            :search="search"
            class="elevation-1"
            :footer-props="{
              'items-per-page-options': [25, 75, 100],
              'items-per-page-text': 'Mostrar',
            }"
            @click:row="handleClickRowTable"
          >
            <template v-slot:[`item.edit`]="{ item }">
              <!-- Modal update product -->
              <b-modal size="xl" :id="`product_${String(item.id)}`" hide-footer>
                <template v-slot:modal-title>Editar produto</template>
                <div class="d-block">
                  <div class="container">
                    <b-overlay :show="loadingProductUpdate" opacity="0.99">
                      <form v-on:submit="update" method="post">
                        <div class="row">
                          <WarningRequiredFields />
                          <ErrorsMessages :errors="errors" />
                          <div class="col-md-8">
                            <LabelRequiredField label="Nome" />
                            <input
                              :disabled="!permissions.standard_product.edit"
                              type="text"
                              v-model="name"
                              class="form-control"
                            />
                          </div>
                          <div class="col-md-2">
                            <LabelRequiredField label="Unidade" />
                            <select
                              :disabled="!permissions.standard_product.edit"
                              v-model="unit_of_measurement_id"
                              class="form-control"
                            >
                              <option
                                v-for="value in unitOfMeasurements"
                                :key="value.id"
                                :value="value.id"
                              >
                                {{ value.name }}
                              </option>
                            </select>
                          </div>
                          <div class="col-md-2">
                            <label>Estoque mínimo</label>
                            <input
                              :disabled="!permissions.standard_product.edit"
                              type="text"
                              v-model="minimum_stock"
                              class="form-control"
                            />
                          </div>
                          <div class="col-md-4">
                            <LabelRequiredField label="Categoria" />
                            <div class="input-group">
                              <select
                                :disabled="!permissions.standard_product.edit"
                                v-model="category_standard_product_id"
                                class="form-control"
                              >
                                <option
                                  v-for="value in categoryProducts"
                                  :key="value.id"
                                  :value="value.id"
                                >
                                  {{ value.name }}
                                </option>
                              </select>
                              <div class="input-group-prepend">
                                <v-btn
                                  v-if="permissions.standard_product.edit"
                                  type="button"
                                  class="v-secondary"
                                  @click="
                                    errors = [];
                                    $bvModal.show('createCategoryProduct');
                                  "
                                >
                                  <span class="fa fa-plus"></span> Novo
                                </v-btn>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <LabelRequiredField label="Custo do produto" />
                            <input
                              :disabled="!permissions.standard_product.edit"
                              type="text"
                              v-model="product_cost"
                              class="form-control"
                              v-on:keyup="handleValueProductCost"
                            />
                          </div>
                          <div class="col-md-4">
                            <label>Lucro(%)</label>
                            <input
                              :disabled="!permissions.standard_product.edit"
                              type="text"
                              v-on:keyup="handleValueProfit"
                              v-model="profit"
                              class="form-control"
                            />
                          </div>
                          <div class="col-md-4">
                            <LabelRequiredField label="Valor da venda" />
                            <input
                              :disabled="!permissions.standard_product.edit"
                              type="text"
                              v-model="sale_price"
                              class="form-control"
                              v-on:keyup="handleValueSalePrice"
                            />
                          </div>
                          <div class="col-md-12">
                            <h6>
                              <span class="text-muted">Criação:</span>
                              {{ formatDate(item.created_at) }}
                            </h6>
                            <h6>
                              <span class="text-muted">Última alteração:</span>
                              {{ formatDate(item.updated_at) }}
                            </h6>
                          </div>
                          <div class="col-md-12 text-right">
                            <v-btn
                              class="v-primary m-1"
                              @click="
                                $bvModal.hide(`product_${String(item.id)}`)
                              "
                            >
                              <span class="fa fa-arrow-left"></span> Voltar
                            </v-btn>
                            <v-btn
                              v-if="permissions.standard_product.edit"
                              :disabled="loadingUpdate"
                              type="submit"
                              class="v-success"
                            >
                              <span class="fa fa-check"></span>
                              {{ loadingUpdate ? "Carregando" : "Salvar" }}
                            </v-btn>
                          </div>
                        </div>
                      </form>
                    </b-overlay>
                  </div>
                </div>
              </b-modal>
              <!-- /Modal update product -->
            </template>
          </v-data-table>
        </v-card>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import WarningRequiredFields from "../templates/components/WarningRequiredFields";
import LabelRequiredField from "../templates/components/LabelRequiredField";
import ErrorsMessages from "../templates/components/ErrorsMessages";
import NavBar from "../templates/NavBar";
import api from "../services/api";
import toast from "../components/ToastNotification";

import {
  formatPrice,
  formatValueOnKeyUp,
  formatValueToOnlyNumber,
  formatValueToPercentage,
  formatDate,
} from "../functions/format";
import { adminData } from "../lib/functions";

export default {
  name: "Product",
  components: {
    NavBar,
    WarningRequiredFields,
    LabelRequiredField,
    ErrorsMessages,
  },
  data() {
    return {
      permissions: {},
      errors: [],
      search: "",
      headers: [
        { text: "Código", sortable: false, value: "id" },
        { text: "Categoria", value: "category_standard_product_name" },
        { text: "Nome", value: "name" },
        { text: "Unidade", value: "unit_of_measurement_name" },
        { align: "end", text: "", sortable: false, value: "edit" },
      ],
      products: [],
      categoryProducts: [],
      unitOfMeasurements: [],
      id: "",
      category_standard_product_id: "",
      unit_of_measurement_id: "",
      name: "",
      product_cost: "",
      profit: "",
      sale_price: "",
      minimum_stock: "",
      loadingCreate: false,
      loadingUpdate: false,
      loadingProductUpdate: false,
      loadingCreateCategory: false,
      category_name: "",
      loading: true,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    formatPrice,
    formatValueOnKeyUp,
    formatValueToOnlyNumber,
    formatValueToPercentage,
    formatDate,
    handleClickRowTable(item) {
      this.errors = [];
      this.handleModalProduct(item.id);
      this.$bvModal.show(`product_${String(item.id)}`);
    },
    handleValueProfit: function (e) {
      var profit = formatValueToPercentage(e.target.value);
      if (profit) {
        var current = formatValueToOnlyNumber(this.product_cost);
        var percentage = profit * current;
        var sale_price = percentage / 100;
        sale_price = parseFloat(sale_price) + parseFloat(current);
        this.sale_price = formatPrice(sale_price);
      } else {
        this.sale_price = formatPrice(0);
      }
    },
    handleValueProductCost: function (e) {
      this.product_cost = formatValueOnKeyUp(e.target.value);

      var current = formatValueToOnlyNumber(e.target.value);
      var sale_price = formatValueToOnlyNumber(this.sale_price);

      if (parseInt(current) <= parseInt(sale_price)) {
        var percentage = parseFloat(sale_price - current);
        var profit = percentage * 100;
        profit = profit / current;
        profit = String(profit);
        this.profit = profit.replace(".", ",");
      }
    },
    handleValueSalePrice: function (e) {
      this.sale_price = formatValueOnKeyUp(e.target.value);

      var current = formatValueToOnlyNumber(this.product_cost);
      var sale_price = formatValueToOnlyNumber(e.target.value);

      if (parseInt(current) <= parseInt(sale_price)) {
        var percentage = parseFloat(sale_price - current);
        var profit = percentage * 100;
        profit = profit / current;
        profit = String(profit);
        this.profit = profit.replace(".", ",");
      }
    },
    retrieve() {
      this.permissions = adminData().permissions;
      this.admin_id = adminData().admin.id;

      this.getProducts();
      this.getCategoryProducts();
      this.getUnitOfMeasurements();
    },
    async getProducts(page = 1) {
      try {
        this.loading = true;

        let params = {
          page,
        };

        const response = await api.get("/admin/standard/product/paginate", {
          params,
        });

        const { products } = response.data;

        this.products = products;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getCategoryProducts() {
      try {
        const response = await api.get("/admin/standard/category/product/all");

        const { categories } = response.data;

        this.categoryProducts = categories;
      } catch (error) {
        console.log(error);
      }
    },
    async getUnitOfMeasurements() {
      try {
        const response = await api.get("/admin/unit-of-measurement/all");

        const { unit_of_measurement } = response.data;

        this.unitOfMeasurements = unit_of_measurement;
      } catch (error) {
        console.log(error);
      }
    },
    async create(event) {
      try {
        event.preventDefault();

        this.loadingCreate = true;

        const {
          category_standard_product_id,
          unit_of_measurement_id,
          name,
          minimum_stock,
          product_cost,
          profit,
          sale_price,
        } = this;

        let params = {
          category_standard_product_id,
          unit_of_measurement_id,
          name,
          minimum_stock,
          product_cost,
          profit,
          sale_price,
        };

        const response = await api.post(
          "/admin/standard/product/create",
          params
        );

        const { error, errors } = response.data;

        if (!error) {
          this.$bvModal.hide("createProduct");
          this.name = "";
          this.category_standard_product_id = "";
          this.unit_of_measurement_id = "";
          this.minimum_stock = "";
          this.product_cost = "";
          this.profit = "";
          this.sale_price = "";
          this.getProducts();
          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loadingCreate = false;
      } catch (error) {
        console.log(error);
      }
    },
    handleModalCreate() {
      this.errors = [];
      this.name = "";
      this.category_standard_product_id = "";
      this.unit_of_measurement_id = "";
      this.minimum_stock = "";
      this.product_cost = "";
      this.profit = "";
      this.sale_price = "";
      this.$bvModal.show("createProduct");
    },
    async update(event) {
      try {
        event.preventDefault();

        this.loadingUpdate = true;

        const {
          id,
          category_standard_product_id,
          unit_of_measurement_id,
          name,
          minimum_stock,
          product_cost,
          profit,
          sale_price,
        } = this;

        let params = {
          id,
          category_standard_product_id,
          unit_of_measurement_id,
          name,
          minimum_stock,
          product_cost,
          profit,
          sale_price,
        };

        const response = await api.put(
          "/admin/standard/product/update",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide(`product_${String(id)}`);
          this.getProducts();
          this.errors = [];
          toast(message, "success");
        } else {
          this.errors = errors;
        }
        this.loadingUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },
    async handleModalProduct(id) {
      try {
        this.loadingProductUpdate = true;

        this.id = id;

        const response = await api.get("/admin/standard/product/get", {
          params: { id },
        });

        const { product } = response.data;

        this.id = product.id;
        this.name = product.name;
        this.category_standard_product_id =
          product.category_standard_product_id;
        this.unit_of_measurement_id = product.unit_of_measurement_id;
        this.minimum_stock = product.minimum_stock;
        this.product_cost = formatPrice(product.product_cost);
        this.profit = product.profit;
        this.sale_price = formatPrice(product.sale_price);
        this.loadingProductUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },
    async createCategory(event) {
      try {
        event.preventDefault();

        this.loadingCreateCategory = true;

        const { category_name } = this;

        let params = { name: category_name };

        const response = await api.post(
          "/admin/standard/category/product/create",
          params
        );

        const { error, errors } = response.data;

        if (!error) {
          this.$bvModal.hide("createCategoryProduct");
          this.category_name = "";
          this.getCategoryProducts();
          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loadingCreateCategory = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>